/**
 * Created by mrocha on 8/16.
 */

import fabric           from  'fabric.js/dist/fabric.require';

//======================================================================================
// Create a  circle shape with text on center
// Targets Behaviors and Workflow canvases.
//======================================================================================
export const CircleWithTextClass = fabric.util.createClass(fabric.Circle, {

    type: 'circle',

    initialize: function(opt) {
        const options = opt || {};

        this.callSuper('initialize', options);
        this.set('label', options.label || '');
        this.set('widgetText',  options.widgetText  || '');

        this.icon = options.icon || '';
        this.fillColor = options.fillColor || '#FFFFFF';

        this.hasControls = true;
        this.hasRotatingPoint = false;
        this.objectCaching = false;
        this.visible = options.visible;
        this.hoverCursor = 'pointer';
    },

    toObject: function() {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            label: this.get('label')
        });
    },


    preparedText: function(originalText) {
        let textLines = originalText? originalText.split('\n'): '';
        const MAXLINES = 4;
        let lineCount = 0;
        let resultLines = [];
        while (resultLines.length < MAXLINES && lineCount < textLines.length){
            let arrayToAdd = this.dividedWords(textLines[lineCount]);
            resultLines = resultLines.concat(arrayToAdd);
            ++lineCount;
        }
        return resultLines;
    },

    dividedWords: function(textline) {
        let textWords = textline? textline.split(' '): [];
        let result = [];
        const maxChars = 7;
        for (let w of textWords) {
            if (w.length > maxChars) {
                result = textline.match(/(.{1,7})/g);
                break;
            } else {
                let index = result.length===0 ? 0 : result.length-1;
                if ((result[index]+ ' '+ w).length < maxChars) {
                    result[index] = result[index]? result[index]+ ' ' + w: w;
                } else {
                    result.push(w);
                }
            }
        }
        return result;
    },

    wrapText: function(context, originalText, x, originalY, lineHeight) {
        let y = originalY - this.radius + 15;
        let widgetHeight = parseInt(this.height)/2;
        let limit= originalText.length <=4 ? originalText.length : 4;
        let difference = (4-limit)/2;

        if ( difference > 0 ) {
            y += (10*difference);
        }

        for (var ii = 0; ii < limit; ii++) {
            context.fillText(originalText[ii], x, y);
            y += lineHeight;
        }
    },

    _render: function(ctx) {
        this.callSuper('_render', ctx);

        ctx.lineWidth = 0.5;

        ctx.fillStyle   = '#FFFFFF';
        ctx.fill();
        ctx.stroke();

        ctx.beginPath();
        ctx.font = '10px Sans-Serif';
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';

        const txtPost = { x: -1.0, y: 1.0};
        this.wrapText(ctx, this.preparedText(this.widgetText), txtPost.x, txtPost.y, 10);
        ctx.closePath();
    }
});

